import React from 'react';
import { Link } from 'react-router-dom';

// The header and footer every app page shares (app-page §1). The landing page
// keeps its own header because its links are in-page anchors.
export function SiteHeader({ cta = { to: '/app', label: 'Open the builder' }, user = null, onSignOut = null }) {
  return (
    <header className="wrap">
      <nav aria-label="Primary">
        <Link className="logo" to="/">Fullrun</Link>
        <div className="links">
          <Link to="/runs">Runs</Link>
          {user
            ? <span className="whoami">signed in as {user.email || user.displayName || 'you'} {onSignOut && <button type="button" className="linklike" onClick={onSignOut}>Sign out</button>}</span>
            : <Link to="/#questions">Questions</Link>}
          {cta && <Link className="btn quiet small" to={cta.to}>{cta.label}</Link>}
        </div>
      </nav>
    </header>
  );
}

// The footer in the format of stratiaadmissions.com's (founder, 2026-09-17): the brand and its
// line on the left, link columns with small headings, a rule, then the copyright line. Only
// pages that exist are linked; a Privacy page and a Contact page are follow-ups.
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="cols">
          <div className="brand">
            <Link className="logo" to="/">Fullrun</Link>
            <p>Software for the hour before you present.</p>
          </div>
          <div className="groups">
            <div><h4>Product</h4><ul><li><Link to="/app">The builder</Link></li><li><Link to="/runs">Runs</Link></li></ul></div>
            <div><h4>Company</h4><ul><li><Link to="/#evidence">Why now</Link></li><li><Link to="/#questions">Questions</Link></li></ul></div>
            <div><h4>Legal</h4><ul><li><Link to="/privacy">Privacy Policy</Link></li><li><Link to="/terms">Terms of Service</Link></li></ul></div>
          </div>
        </div>
        <div className="legal">{'\u00a9'} 2026 Fullrun {'\u00b7'} San Francisco, CA</div>
      </div>
    </footer>
  );
}
